import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface Notice {
  id: number
  message: string
  tone: 'success' | 'error' | 'info'
}

export const useNoticeStore = defineStore('notice', () => {
  const notices = ref<Notice[]>([])
  let nextID = 1

  function show(message: string, tone: Notice['tone'] = 'info'): void {
    const notice = { id: nextID++, message, tone }
    notices.value.push(notice)
    window.setTimeout(() => dismiss(notice.id), 3600)
  }

  function dismiss(id: number): void {
    notices.value = notices.value.filter((notice) => notice.id !== id)
  }

  return { notices, show, dismiss }
})
